import * as PopperJS from "@popperjs/core";
import { Tooltip } from "~/components/Tooltip";
import { cn } from "~/lib/utils";
import { MANAGE_PERMISSION_REQUIRED } from "../../consts";

// // // //

/**
 * ManagePermissionTooltip
 * Wraps a control that is disabled because the current user can't manage the
 * client, explaining why on hover / focus. Renders `children` untouched when
 * the user can manage the client.
 *
 * NOTE - the trigger is a wrapping `span` because disabled buttons don't emit
 * the pointer events the tooltip listens for.
 */
export function ManagePermissionTooltip(props: {
    canManage: boolean;
    placement?: PopperJS.Placement;
    className?: string;
    children: React.ReactNode;
}) {
    const { canManage, placement = "top", className, children } = props;

    if (canManage) {
        return <>{children}</>;
    }

    return (
        <Tooltip
            placement={placement}
            tooltipContent={
                <div className="max-w-xs px-3 py-2 text-sm">
                    {MANAGE_PERMISSION_REQUIRED}
                </div>
            }
        >
            {({ setTriggerRef }) => (
                <span
                    ref={setTriggerRef}
                    tabIndex={0}
                    className={cn(
                        "inline-flex shrink-0 cursor-not-allowed",
                        className,
                    )}
                >
                    {children}
                </span>
            )}
        </Tooltip>
    );
}
